const StudentProgressReportReflectionTypePolicy = {
  StudentProgressReportReflection: {
    keyFields: ["studentProgressReportId"],
  },
};

export default StudentProgressReportReflectionTypePolicy;
